export const MAX_CUSTOM_OBJECT_DEFINITIONS = 3;

export const CUSTOM_OBJECT_BASE_PATH = 'core/custom-objects';
